<template>
  <body class="mission-body" id="mission">
    <div class="mission-wrapper">
      <TextLabel labelColor="white" labelText="Our Mission" />
      <div class="title">Our Mission: Reducing Waste, Preserving Resources</div>
    </div>
  </body>
</template>

<script>
import TextLabel from "../../Sustainability/Content/ReusableComponents/TextLabel.vue";

export default {
  name: "Mission",
  components: {
    TextLabel,
  },
};
</script>

<style scoped>
.mission-body {
  width: 100%;
  height: 482px;
  border-radius: 20px;
  background-image: url("../../../assets/sustainability/mission.png");
  background-repeat: no-repeat;
  background-size: cover;
}
.mission-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.title {
  max-width: 704px;
  font-size: 45px;
  font-weight: 600;
  color: #ffffff;
  text-align: center;
}

@media (max-width: 1024px) {
  .mission-body {
    height: 350px;
  }
  .button {
    width: 96px;
    height: 22px;
    font-size: 12px;
  }
  .title {
    max-width: 618px;
    font-size: 30px;
  }
}
@media (max-width: 744px) {
  .mission-body {
    height: 250px;
  }
  .button {
    width: 96px;
    height: 22px;
    font-size: 12px;
  }
  .title {
    max-width: 500px;
    font-size: 25px;
  }
}

@media (max-width: 588px) {
  .mission-body {
    height: 250px;
  }
  .title {
    max-width: 500px;
    font-size: 25px;
  }
}

@media (max-width: 588px) {
  .mission-body {
    height: 266px;
  }
  .title {
    max-width: 358px;
    font-size: 25px;
  }
}
</style>
